"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.htmlMixin = exports.HTML = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _helpers = require("../../helpers");

var _space = require("../../helpers/space");

var _Text = require("../Text");

var _excluded = ["html"],
    _excluded2 = ["children"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * Sets reasonable defaults for tags that we might encounter in Markdown output.
 */


var htmlMixin = (0, _styledComponents.css)(["h1,h2,h3,h4,h5,ul,ol,p,blockquote,pre,hr{margin:", "px auto;&:first-child{margin-top:0;}&:last-child{margin-bottom:0;}}hr{height:1px;border:0;background-color:", ";}"], (0, _space.space)(1), (0, _helpers.color)("black10"));
exports.htmlMixin = htmlMixin;
var Container = (0, _styledComponents.default)(_Text.Text).withConfig({
  displayName: "HTML__Container",
  componentId: "sc-1im40xc-0"
})(["", ""], htmlMixin);
Container.defaultProps = {
  variant: "text"
};
/**
 * Sets reasonable defaults for tags that we might encounter in Markdown output.
 * If `html` prop is passed; it's set as innerHTML, otherwise contents are wrapped
 * with default HTML styling.
 */

var HTML = function HTML(props) {
  if ("html" in props) {
    var html = props.html,
        htmlRest = _objectWithoutProperties(props, _excluded);

    return /*#__PURE__*/_react.default.createElement(Container, _extends({
      dangerouslySetInnerHTML: {
        __html: html
      }
    }, htmlRest));
  }

  var children = props.children,
      childrenRest = _objectWithoutProperties(props, _excluded2);

  return /*#__PURE__*/_react.default.createElement(Container, childrenRest, children);
};

exports.HTML = HTML;
HTML.displayName = "HTML";
HTML.displayName = "HTML";